// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gwnQu","head":"Table_head__3pYaq","col":"Table_col__3KUY5"};